const COMMENT_TYPE = {
    NORMAL: '1',
    AUDIT: '2',
    HIDE: '3',
    CLOSE: '4'
};

const COMMENT_STATUS = {
    [COMMENT_TYPE.NORMAL]: '正常评论',
    [COMMENT_TYPE.AUDIT]: '必审评论',
    [COMMENT_TYPE.HIDE]: '隐藏评论',
    [COMMENT_TYPE.CLOSE]: '关闭评论'
};

const CONTENT_TYPE = {
    ARTICLE: '1',
    VIDEO: '3',
    SUBJECT: '4'
};

const CONTENT_MAP = {
    [CONTENT_TYPE.ARTICLE]: '文章',
    [CONTENT_TYPE.VIDEO]: '视频',
    [CONTENT_TYPE.SUBJECT]: '专题'
};

export default {
    status: COMMENT_STATUS,
    type: COMMENT_TYPE,
    CONTENT_MAP: CONTENT_MAP,
    CONTENT_TYPE: CONTENT_TYPE,
    mark: ['视频', '图集', '热门', '实时'],
    province: [
        '北京市',
        '上海市',
        '天津市',
        '江苏省',
        '重庆市',
        '河北省',
        '安徽省',
        '浙江省',
        '广东省',
        '福建省',
        '山西省',
        '辽宁省',
        '吉林省',
        '黑龙江省',
        '山东省',
        '河南省',
        '湖北省',
        '湖南省',
        '海南省',
        '四川省',
        '贵州省',
        '云南省',
        '陕西省',
        '甘肃省',
        '青海省',
        '江西省',
        '西藏自治区',
        '广西壮族自治区',
        '内蒙古自治区',
        '宁夏回族自治区',
        '新疆维吾尔自治区',
        '香港',
        '澳门',
        '台湾'
    ]
};
